var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledLink, ContentWrapper, TextWrapper, ArrowIcon } from './Link.style';
export const Link = (_a) => {
    var { children, target, hideIcon, underline, disabled, href, onClick } = _a, props = __rest(_a, ["children", "target", "hideIcon", "underline", "disabled", "href", "onClick"]);
    const handleClick = (e) => {
        if (disabled) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (onClick && !disabled) {
            onClick(e);
        }
    };
    return (_jsx(StyledLink, Object.assign({}, props, { href: disabled ? undefined : href, target: disabled ? undefined : target, disabled: disabled, onClick: handleClick }, (target === '_blank' && !disabled && {
        rel: 'noopener noreferrer'
    }), { children: _jsxs(ContentWrapper, { children: [_jsx(TextWrapper, { underline: underline, children: children }), !hideIcon && _jsx(ArrowIcon, {})] }) })));
};
//# sourceMappingURL=Link.js.map